var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#d10a11"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(6.154 6.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3377",
    "data-name": "Path 3377",
    d: "M-835.691,116.429a19.232,19.232,0,0,1-19.2-19.237,19.227,19.227,0,0,1,19.259-19.225,19.228,19.228,0,0,1,19.2,19.282A19.226,19.226,0,0,1-835.691,116.429Zm13.4-9.306a16.609,16.609,0,0,0-2.037-22.2,16.709,16.709,0,0,0-23.187.517,16.54,16.54,0,0,0-1.5,21.672c.058-.073.117-.138.164-.211a9.127,9.127,0,0,1,8.037-4.426c3.444-.026,6.891-.016,10.335,0a9.135,9.135,0,0,1,7.5,3.658C-822.742,106.446-822.528,106.787-822.293,107.124Zm-13.343-2.091c-1.91,0-3.823-.072-5.729.017a6.433,6.433,0,0,0-5.694,3.808.448.448,0,0,0,.121.644,16.459,16.459,0,0,0,12.719,4.326,16.438,16.438,0,0,0,9.872-4.354.4.4,0,0,0,.107-.571,6.433,6.433,0,0,0-5.712-3.853C-831.842,104.961-833.74,105.034-835.636,105.033Z",
    transform: "translate(854.892 -77.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3378",
    "data-name": "Path 3378",
    d: "M-718.959,172.366a7.185,7.185,0,0,1,2.744-5.225,6.541,6.541,0,0,1,9.017.534,7.959,7.959,0,0,1,.3,10.572,6.652,6.652,0,0,1-10.695-.63A8.548,8.548,0,0,1-718.959,172.366Zm2.526.341a6,6,0,0,0,.548,2.833,4.176,4.176,0,0,0,6.8,1.346,5.427,5.427,0,0,0,.276-7.228,4.027,4.027,0,0,0-5.127-1.014A4.814,4.814,0,0,0-716.433,172.706Z",
    transform: "translate(731.232 -157.679)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f5765216a78c742b5eb23cc48338c482.svg";
export { ForwardRef as ReactComponent };